/* New product card (Amanda, Oct 23, 2026): photo dots + "Choose" sheet with several styles and quantities.
   Uses the card's hidden .variant-select (snippets/product-item.liquid) so main.js still swaps the photo,
   price and Add button when a style is picked, and cart.js refreshes the bag. */
(function () {
  var bg, sheet, state = null;
  function money(cents) { var d = cents / 100; return "$" + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  function cents(txt) { var n = parseFloat(String(txt || "").replace(/[^0-9.]/g, "")); return isNaN(n) ? 0 : Math.round(n * 100); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function pickStyle(card, id) {
    var sel = card.querySelector(".variant-select");
    if (!sel) return;
    sel.value = id;
    sel.dispatchEvent(new Event("change", { bubbles: true }));
    card.querySelectorAll(".bc-dot").forEach(function (d) { d.classList.toggle("on", d.dataset.variant === String(id)); });
  }

  function build() {
    bg = document.createElement("div"); bg.className = "bc-sheet-bg";
    sheet = document.createElement("div"); sheet.className = "bc-sheet"; sheet.setAttribute("role", "dialog"); sheet.setAttribute("aria-modal", "true"); sheet.setAttribute("aria-label", "Choose a style");
    document.body.appendChild(bg); document.body.appendChild(sheet);
    bg.addEventListener("click", close);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && document.documentElement.classList.contains("bc-open")) close(); });
  }
  function close() { document.documentElement.classList.remove("bc-open"); state = null; }

  function open(card) {
    if (!sheet) build();
    var sel = card.querySelector(".variant-select"); if (!sel) return;
    var title = (card.querySelector(".details .title") || {}).textContent || "";
    var img = card.querySelector(".swiper-slide img, .hover-gallery img");
    var opts = [].slice.call(sel.options).filter(function (o) { return o.value && !isNaN(Number(o.value)); });
    state = { card: card, opts: opts };
    var h = '<div class="grab"></div><div class="top">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : "") + '<span class="t">' + esc(title.trim()) + '</span><button type="button" class="x" aria-label="Close"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="#fff" stroke-width="2.6" stroke-linecap="round"/></svg></button></div>';
    h += '<div class="lbl">Pick styles · use − / + for more than one</div><div class="opts">';
    opts.forEach(function (o, i) {
      var ok = o.dataset.available === "true";
      h += '<div class="opt' + (ok ? "" : " out") + '" role="button" tabindex="' + (ok ? 0 : -1) + '" aria-disabled="' + !ok + '" data-i="' + i + '" data-q="1">' +
        (o.dataset.img ? '<img src="' + esc(o.dataset.img) + '" alt="" loading="lazy">' : "") +
        '<span class="nm">' + esc(o.dataset.title || o.textContent.trim()) + '</span><span class="op">' + (ok ? esc(money(cents(o.dataset.price))) : "Sold out") + '</span>' +
        (ok ? '<span class="qty"><button type="button" class="qm" aria-label="One fewer">−</button><b>1</b><button type="button" class="qp" aria-label="One more">+</button></span>' : "") + '</div>';
    });
    h += '</div><p class="err" hidden></p><button type="button" class="add" disabled>Pick a style</button>';
    sheet.innerHTML = h;
    sheet.querySelector(".x").addEventListener("click", close);
    var add = sheet.querySelector(".add");
    function sum() {
      var chosen = [].slice.call(sheet.querySelectorAll(".opt.sel")), n = 0, total = 0;
      chosen.forEach(function (x) { var q = +x.dataset.q; n += q; total += q * cents(opts[+x.dataset.i].dataset.price); });
      add.disabled = !chosen.length;
      add.textContent = !chosen.length ? "Pick a style" : (n === 1 ? "+ Add " + (opts[+chosen[0].dataset.i].dataset.title || "").slice(0, 22) : "+ Add " + n + " pieces") + " · " + money(total);
    }
    function setQ(o, q) { o.dataset.q = q; o.querySelector(".qty b").textContent = q; }
    sheet.querySelectorAll(".opt:not(.out)").forEach(function (o) {
      var max = Math.max(1, parseInt(opts[+o.dataset.i].dataset.max, 10) || 9);
      o.addEventListener("click", function (e) { if (e.target.closest(".qty")) return; if (o.classList.toggle("sel")) setQ(o, 1); sum(); });
      o.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); o.click(); } });
      o.querySelector(".qp").addEventListener("click", function () { setQ(o, Math.min(max, +o.dataset.q + 1)); sum(); });
      o.querySelector(".qm").addEventListener("click", function () { var q = +o.dataset.q - 1; if (q < 1) { o.classList.remove("sel"); q = 1; } setQ(o, q); sum(); });
    });
    add.addEventListener("click", function () {
      var items = [].slice.call(sheet.querySelectorAll(".opt.sel")).map(function (x) { return { id: Number(opts[+x.dataset.i].value), quantity: +x.dataset.q }; });
      if (!items.length) return;
      var err = sheet.querySelector(".err"); err.hidden = true; add.disabled = true; add.textContent = "Adding…";
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { err.textContent = res.d.description || "Couldn't add that. Try fewer pieces."; err.hidden = false; sum(); return; }
          var n = items.reduce(function (t, x) { return t + x.quantity; }, 0);
          add.textContent = (n > 1 ? n + " pieces added" : "Added to bag") + " ✓";
          if (typeof getCartContents === "function") getCartContents();
          setTimeout(function () { close(); var sc = document.getElementById("side-cart"); if (sc) sc.classList.add("active"); }, 650);
        })
        .catch(function () { err.textContent = "Couldn't reach the bag. Check your connection and try again."; err.hidden = false; sum(); });
    });
    document.documentElement.classList.add("bc-open");
    setTimeout(function () { var f = sheet.querySelector(".opt:not(.out)"); if (f) f.focus({ preventScroll: true }); }, 260);
  }

  /* Capture phase so this runs before the old "Pick one" handlers on cards that have no style picked yet */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var dot = t.closest && t.closest(".bc-card .bc-dot");
    if (dot) { e.preventDefault(); pickStyle(dot.closest(".bc-card"), dot.dataset.variant); return; }
    var more = t.closest && t.closest(".bc-card .bc-more");
    if (more) { e.preventDefault(); open(more.closest(".bc-card")); return; }
    var btn = t.closest && t.closest(".bc-card.bc-multi .plp-atc-btn");
    if (btn && !btn.closest(".bc-card").classList.contains("atc-on")) { e.preventDefault(); e.stopImmediatePropagation(); open(btn.closest(".bc-card")); }
  }, true);
  /* Back/forward restore: never leave the sheet open */
  window.addEventListener("pageshow", function (e) { if (e.persisted) close(); });
})();

/* Bag (Amanda, Oct 24, 2026): show the product name above the style, and − / + quantity for items with more than one in stock.
   Max per item comes from templates/product.bc-stock.liquid (capped at 9); cart.js re-renders the bag after each change. */
(function () {
  var cache = {};
  function maxFor(handle, vid) {
    if (!cache[handle]) cache[handle] = fetch("/products/" + handle + "?view=bc-stock").then(function (r) { return r.text(); })
      .then(function (t) { try { return JSON.parse(t).variants || {}; } catch (e) { return {}; } }).catch(function () { return {}; });
    return cache[handle].then(function (m) { return m[vid]; });
  }
  function change(key, qty) {
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(function () { if (typeof getCartContents === "function") getCartContents(); else location.reload(); });
  }
  function enhance() {
    var loop = document.querySelector("#side-cart .cart-loop");
    if (!loop) return;
    var els = [].slice.call(loop.querySelectorAll(".item[data-key]"));
    if (!els.length) return;
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      els.forEach(function (el) {
        var it = cart.items.filter(function (i) { return i.key === el.dataset.key; })[0];
        var det = el.querySelector(".details");
        if (!it || !det) return;
        if (!det.querySelector(".bc-ci-title") && !det.querySelector(".title") && it.product_title) {
          var a = document.createElement("a"); a.className = "bc-ci-title"; a.href = it.url; a.textContent = it.product_title;
          det.insertBefore(a, det.firstChild);
        }
        var q = el.querySelector(".bottom-bar .qty");
        if (!q || q.dataset.bc === "1") return;
        q.dataset.bc = "1";
        maxFor(it.handle, it.variant_id).then(function (max) {
          max = max === undefined ? 9 : Number(max);
          if (max <= 1 && it.quantity <= 1) { q.textContent = "Qty 1"; return; }
          q.innerHTML = '<span class="bc-qty"><button type="button" class="bc-qm" aria-label="One fewer">−</button><b>' + it.quantity + '</b><button type="button" class="bc-qp" aria-label="One more"' + (it.quantity >= max ? " disabled" : "") + ">+</button></span>";
          q.querySelector(".bc-qm").addEventListener("click", function () { change(it.key, it.quantity - 1); });
          q.querySelector(".bc-qp").addEventListener("click", function () { if (it.quantity < max) change(it.key, it.quantity + 1); });
        });
      });
    });
  }
  var loop = document.querySelector("#side-cart .cart-loop");
  if (loop) { new MutationObserver(function () { setTimeout(enhance, 30); }).observe(loop, { childList: true }); enhance(); }
})();
